<template>
    <div>
        <div v-if="showDocumentButtons">
            <div v-if="waitingForAddress" class="text-warning">
                {{ __('orders.address.loading') }}
            </div>
            <div v-if="addressDeleted" class="text-warning">
                {{ __('orders.address.deleted') }}
            </div>

            <OrderDocumentActions :order="order"
                                  :document-type="OrderDocumentType.INVOICE"
                                  :waiting-for-address="waitingForAddress"
                                  :address-deleted="addressDeleted"
            />
            <OrderDocumentActions :order="order"
                                  :document-type="OrderDocumentType.DELIVERY_NOTE"
                                  :waiting-for-address="waitingForAddress"
                                  :address-deleted="addressDeleted"
            />
            <OrderDocumentActions :order="order"
                                  :document-type="OrderDocumentType.RETURN"
                                  :waiting-for-address="waitingForAddress"
                                  :address-deleted="addressDeleted"
            />
        </div>
        <div v-else class="d-flex flex-column gap-1">
            <div>
                {{ __('orders.documents.only_storefront') }}
            </div>
            <div v-if="isAmazonOrder"
                 v-html="__('orders.documents.view_seller_central')"
            />
        </div>
    </div>
</template>

<script>
import OrderDocumentActions from "@components/Orders/OrderDocumentActions.vue";
import {OrderDocumentType} from "@generated/orderDocumentType";
import {IntegrationCodeEnum} from '@generated/integrationCodeEnum';


export default {
    components: {
        OrderDocumentActions
    },

    props: {
        order: Object,
        store: Object
    },

    data() {
        return {
            loading: false,
        }
    },

    computed: {
        IntegrationCodeEnum() {
            return IntegrationCodeEnum
        },

        OrderDocumentType() {
            return OrderDocumentType
        },

        isWaitingForIntegration() {
            return this.order.state === 'wait_for_integration';
        },

        isPending() {
            return this.order.state === 'pending';
        },

        isConfirmed() {
            return this.order.state === 'confirmed';
        },

        isReadyForPickup() {
            return this.order.state === 'pickup';
        },

        showDocumentButtons() {
            return [
                IntegrationCodeEnum.YouBuyDa,
                IntegrationCodeEnum.MerchantCenter
            ].includes(this.order.integration.code)
        },

        isAmazonOrder() {
            return [
                IntegrationCodeEnum.AmazonMFN,
                IntegrationCodeEnum.AmazonTODAY,
                IntegrationCodeEnum.AmazonBOPIS,
            ].includes(this.order.integration.code)
        },

        waitingForAddress() {
            return this.order.addresses.length === 0 &&
                (this.isPending || this.isWaitingForIntegration || this.isReadyForPickup || this.isConfirmed);
        },

        addressDeleted() {
            return this.order.addresses.length === 0 &&
                !(this.isPending || this.isWaitingForIntegration || this.isReadyForPickup || this.isConfirmed);
        },
    }
}
</script>
